// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__tHeBE","body":"styles_body__GeVOw","head":"styles_head__0UAnj"};